/**
 * Tipos de respuesta del Ws Segmentador
 */
export enum SegmenterCodes {
    OK = 200,
    CLIENT_NOT_FOUND = 206,
    MISSING_PARAMETERS = 400,
    ERROR = 500
}
